import type { Theme } from '@mui/material';

export const udbtfGuaranteeIssueDetailsSectionStyles = {
  fieldsGrid: (theme: Theme) => ({
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      md: 'repeat(3, minmax(0, 1fr))',
    },
    gap: theme.spacing(1.5),
  }),
  readOnlyField: (theme: Theme) => ({
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.common.white,
      opacity: 1,
    },
    '& .MuiInputBase-root.Mui-disabled': {
      backgroundColor: theme.palette.common.white,
      opacity: 1,
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: theme.palette.common.white,
      opacity: 1,
    },
    '& .MuiInputBase-input.Mui-disabled, & .MuiOutlinedInput-input.Mui-disabled': {
      color: theme.palette.text.primary,
      WebkitTextFillColor: theme.palette.text.primary,
      opacity: 1,
    },
  }),
} as const;
